(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/syndicate/account-selector/assets/javascripts/models/account.js') >= 0) return;  svs.modules.push('/components/syndicate/account-selector/assets/javascripts/models/account.js');
(function(Backbone, _, svs) {
  'use strict';

  svs.syndicate.account_selector.models.Account = Backbone.Model.extend({
    preserve: true,
    preserveBindings: true,
    url: function() {
      return svs.core.jupiter.url() + '/social/1/syndicates/' + this.get('syndicateId');
    },
    initialize: function() {
      this.set('isSyndicate', this.isSyndicateActive());
    },
    setUser: function(balance) {
      this.set({
        playableAmount: balance,
        syndicateName: 'Mitt spelkonto',
        syndicateId: 'user',
        displayAccount: true,
        isSyndicate: false
      });
    },
    setSyndicate: function(syndicateModel) {
      this.set({
        playableAmount: svs.utils.format.Currency(syndicateModel.get('playableAmount')),
        syndicateName: syndicateModel.get('syndicateName'),
        syndicateId: syndicateModel.get('syndicateId'),
        displayAccount: true,
        isSyndicate: true
      });
    },
    setSyndicateByIdAndFetch: function(syndicateId) {
      this.set({
        syndicateId: syndicateId,
        isSyndicate: true,
        displayAccount: true
      });
      this.fetch({ parse: true });
    },
    isSyndicateActive: function() {
      return (this.get('syndicateId') && this.get('syndicateId') !== 'user') || false;
    },
    parse: function(data) {
      if (!data.error && data.syndicate) {
        this.set({
          playableAmount: svs.utils.format.Currency(data.syndicate.playableAmount),
          syndicateName: data.syndicate.syndicateName
        });
      }
    }
  });
})(Backbone, _, svs);


 })(window);